import React, { useEffect } from "react";
import "./styles.scss";
import { NewsGroup, TrendingNewsCard } from "../../../components";
import { withRouter } from "react-router-dom";
import { getLanguage } from "../../../utils/environment";
import { getNewsByTopTags } from "../../news/service/news.service";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const language = getLanguage();

const Index = (props) => {
  const location = useLocation();
  const [topTagsNews, setTopTagsNews] = React.useState([]);

  useEffect(() => {
    async function fetchPageData() {
      try {
        const getNews = await getNewsByTopTags();
        console.log("GetTrendingNews", getNews);

        if (getNews?.data) {
          // dispatch(setNewsList(getNews?.data));
          setTopTagsNews(getNews?.data?.tags);
        } else {
          console.error("No data found for trending news");
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      }
    }

    fetchPageData();
  }, [location.pathname]);

  return (
    <>
      {topTagsNews?.length > 0 &&
        topTagsNews.map((tag, index) => (
          <NewsGroup
            data={{
              titleName: tag?.tag_name || "",
              type: "en",
              linkName: "",
            }}
            // onClickViewNews={() => {
            //   props.history.push("/" + categoryId);
            //   props.setMenuName(categoryId);
            // }}
          >
            {Array.isArray(tag?.news) && tag?.news.length > 0 ? (
              tag?.news.map((data, index) => (
                <TrendingNewsCard
                  data={{
                    isBorder: index + 1 < tag?.news.length,
                    isTrendingNo: false,
                    trendingNo: index + 1,
                    isDate: false,
                    img_url: data?.images?.[0]?.url,
                    header: data?.title[language],
                    content: data?.content,
                    tagViews: data?.views,
                    createAt: data?.created_at,
                    publish_date: data?.created_at,
                  }}
                  onClick={() => {
                    if (data?.keywords?.[language]) {
                      props.history.push(
                        `/${data?.keywords?.[language]}/${data?.news_id}`
                      );
                    } else {
                      const generatedSlug = data?.title?.[language]
                        ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                        ?.replace(/\//g, "")
                        ?.replace(/\s*-\s*/g, " ")
                        ?.trim()
                        .split(/\s+/)
                        .slice(0, 5)
                        .join("-")
                        .replace(/-+/g, "-");
                      props.history.push(`/${generatedSlug}/${data?.news_id}`);
                    }
                  }}
                  // onClick={() => {}}
                />
              ))
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <h6 className="text-muted">No Trending News Available</h6>
              </div>
            )}
          </NewsGroup>
        ))}
    </>
  );
};
export default withRouter(Index);
// export default Index;
